import { render, staticRenderFns } from "./FrontNews.vue?vue&type=template&id=38a6f016&scoped=true&"
import script from "./FrontNews.vue?vue&type=script&lang=js&"
export * from "./FrontNews.vue?vue&type=script&lang=js&"
import style0 from "./FrontNews.vue?vue&type=style&index=0&id=38a6f016&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a6f016",
  null
  
)

export default component.exports